function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_DOCUMENTBYPERSONIDANDTYPEID_REQUEST = "GET_DOCUMENTBYPERSONIDANDTYPEID_REQUEST";
export var GET_DOCUMENTBYPERSONIDANDTYPEID_SUCCESS = "GET_DOCUMENTBYPERSONIDANDTYPEID_SUCCESS";
export var GET_DOCUMENTBYPERSONIDANDTYPEID_FAILURE = "GET_DOCUMENTBYPERSONIDANDTYPEID_FAILURE";
export var RESET_GET_DOCUMENTBYPERSONIDANDTYPEID = "RESET_GET_DOCUMENTBYPERSONIDANDTYPEID";

// Fetches a particular document from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchDocumentByPersonIdAndTypeId = function fetchDocumentByPersonIdAndTypeId(personId, typeId) {
  var queryString = urlSearchParams({
    projection: "withMedia",
    personId: personId,
    typeId: typeId
  });
  return _defineProperty({
    personId: personId,
    typeId: typeId
  }, CALL_API, {
    types: [GET_DOCUMENTBYPERSONIDANDTYPEID_REQUEST, GET_DOCUMENTBYPERSONIDANDTYPEID_SUCCESS, GET_DOCUMENTBYPERSONIDANDTYPEID_FAILURE],
    endpoint: "documents/search/findByPerson_IdAndType_Id".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var POST_DOCUMENT_REQUEST = "POST_DOCUMENT_REQUEST";
export var POST_DOCUMENT_SUCCESS = "POST_DOCUMENT_SUCCESS";
export var POST_DOCUMENT_FAILURE = "POST_DOCUMENT_FAILURE";
export var RESET_POST_DOCUMENT = "RESET_POST_DOCUMENT";
export var postDocument = function postDocument(document) {
  return function (dispatch, getState) {
    var endpoint = "documents";
    if (document.id) endpoint += "/".concat(document.id);
    return dispatch(_defineProperty({
      document: document
    }, CALL_API, {
      types: [POST_DOCUMENT_REQUEST, POST_DOCUMENT_SUCCESS, POST_DOCUMENT_FAILURE],
      endpoint: endpoint,
      init: {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(document),
        credentials: "same-origin"
      }
    }));
  };
};
export var postDocumentFailure = function postDocumentFailure(message) {
  return function (dispatch, getState) {
    return dispatch({
      response: {
        message: message
      },
      type: POST_DOCUMENT_FAILURE
    });
  };
};
export var resetPostDocument = function resetPostDocument() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_POST_DOCUMENT
    });
  };
};